module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Leave_Tomorrow_Behind2#Contents-A"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "body para-style-override-3"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Dance, dance, dance little lady")])]), _vm._v(" "), _c('p', {
    staticClass: "body para-style-override-3"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("So obsessed with second best")])]), _vm._v(" "), _c('p', {
    staticClass: "body para-style-override-3"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("No rest you’ll ever find")])]), _vm._v(" "), _c('p', {
    staticClass: "body para-style-override-3"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Time and tide and trouble")])]), _vm._v(" "), _c('p', {
    staticClass: "body para-style-override-3"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Never, never wait")])]), _vm._v(" "), _c('p', {
    staticClass: "body para-style-override-3"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Let the cauldron bubble")])]), _vm._v(" "), _c('p', {
    staticClass: "body para-style-override-3"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Justify your fate")])]), _vm._v(" "), _c('p', {
    staticClass: "body para-style-override-3"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Dance, dance, dance little lady")])]), _vm._v(" "), _c('p', {
    staticClass: "body para-style-override-3"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Dance, dance, dance little lady")])]), _vm._v(" "), _c('p', {
    staticClass: "body para-style-override-3"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Leave tomorrow behind.")])]), _vm._v(" "), _c('p', {
    staticClass: "body para-style-override-4"
  }, [_vm._v("—Noel Coward")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5359364","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Leave_Tomorrow_Behind-5.vue
// module id = 75
// module chunks = 0